import { render, staticRenderFns } from "./NewsPc.vue?vue&type=template&id=619cc96e&scoped=true"
import script from "./NewsPc.vue?vue&type=script&lang=js"
export * from "./NewsPc.vue?vue&type=script&lang=js"
import style1 from "./NewsPc.vue?vue&type=style&index=1&id=619cc96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619cc96e",
  null
  
)

export default component.exports